import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

type Props = {
  eyebrow?: string;
  title: string;
  body?: string;
  image?: string;
  showCTA?: boolean;
};

export function PageHero({ eyebrow, title, body, image, showCTA = true }: Props) {
  return (
    <section className="relative isolate overflow-hidden border-b border-border bg-jet">
      {image && (
        <>
          <img
            src={image}
            alt=""
            aria-hidden
            className="absolute inset-0 h-full w-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-jet/70 via-jet/85 to-jet" aria-hidden />
        </>
      )}
      <div className="container-x relative py-20 md:py-28 max-w-3xl">
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-copper">{eyebrow}</p>
        )}
        <span className="copper-rule mt-5" />
        <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl text-silver-light text-balance">{title}</h1>
        {body && <p className="mt-5 text-lg text-silver max-w-2xl">{body}</p>}
        {showCTA && (
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/quote"
              className="inline-flex items-center justify-center rounded-sm bg-copper px-7 py-4 text-sm font-bold uppercase tracking-wider text-white hover:bg-copper-hover transition-colors"
            >
              Get Free Quote
            </Link>
            <a
              href={SITE.phoneHref}
              className="hero-phone-cta inline-flex items-center justify-center gap-2 rounded-sm border px-7 py-4 text-sm font-bold uppercase tracking-wider transition-colors"
            >
              <Phone className="h-4 w-4" /> {SITE.phone}
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
